let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iQ0Jm"), load("gLGsg"), load("krOJz")]).then(() => parcelRequire('lMhQj'));